/**
 * Created with IntelliJ IDEA.
 * User: shahara
 * Date: 19/05/2014
 * Time: 07:48 AM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

	var LE = require("app");
    var Media = require("media");
    var Page = require("ui.components/page/Page");
    var LanguageSettingsPageView = require("manager-views/languages-settings/LanguageSettingsPageView");
    var SettingsCollection = require("collections/SettingsCollection");

    var LanguageSelectionController = {};

    var EVENT_PREFIX = "LanguageSettings";
    var KP_ID = "manage-languages-predefined";

    // protected language cannot be removed from selected language list
    var PROTECTED_LANGUAGE = LE.translator.translate("LEFramework.account.lang.en-US.code");

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        LanguageSelectionController = Marionette.Controller.extend({
            vent: null,

            initialize: function (options) {
                LEManager.logger.debug("Create private vent and bind to events","LanguageSelectionController:initialize");
                this.settingsCollection = new SettingsCollection();
                this.vent = Media.vent();
                this._initPageComponent();
                this._bind();
            },

            _bind: function () {
                this.listenTo(this.vent, EVENT_PREFIX + ":Save", _.bind(this._handleSaveEvent, this));
                this.listenTo(this.vent, EVENT_PREFIX + ":Close", _.bind(this._handleCloseEvent, this));
            },

            _handleSaveEvent : function (defaultLanguageCode, selectedLanguageCodes) {
                var that = this;
                this.settingsCollection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.DEFAULT_SUPPORTED_LANGUAGE).setValue(defaultLanguageCode);
                this.settingsCollection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.SUPPORTED_LANGUAGES).setValue(selectedLanguageCodes);
                LEManager.logger.debug("The event was " + EVENT_PREFIX + ":Save","LanguageSelectionController:_bind");
                this.settingsCollection.update({
                    success: function() {
                        // saved successfully
                        LE.siteSettings.supportedLanguageSettings.supportedDefaultLanguageCodesChange(selectedLanguageCodes, defaultLanguageCode);
                        that._navigateOut();
                    },
                    error: function (collection, response) {
                        LEManager.logger.error("Failed saving language settings", "LanguageSelectionPageView:onSaveButtonClicked");
                        if (response && response.responseError && !_.isEmpty(response.responseError.message)) {
                            LEManager.notifier.showError({content : response.responseError.message, timeToShow : 6000});
                        }
                    }
                });

            },

            _handleCloseEvent :function () {
                LEManager.logger.debug("The event was " + EVENT_PREFIX + ":Close","LanguageSelectionController:_bind");
                this._navigateOut();
            },

            _initPageComponent: function() {
                this.languageSelectionPageView = new Page({
                    moduleName:LEManager.moduleName,
                    context:LE.context,
                    header: {
                        title: LE.translator.translate("LEManager.manager.languageSettings.page.title"),
                        description: LE.translator.translate("LEManager.manager.languageSettings.page.description"),
                        knowledgePack: {
                            text: LE.translator.translate("LEManager.manager.languageSettings.page.kpCaption"),
                            eventId: KP_ID
                        }
                    }
                });
                this.listenTo(this.languageSelectionPageView, "close", this._onClosePage);
            },

            _getPageInnerView: function () {
                var options = {
                    vent: this.vent,
                    eventPrefix: EVENT_PREFIX,
                    protectedLanguage: PROTECTED_LANGUAGE
                };
                return new LanguageSettingsPageView(options);
            },

            showLanguagesPage: function() {
                LEManager.logger.debug ("show languages page","LanguageSelectionController:showLanguagesPage");

                this.languageSelectionPageView.showLoader();

                var success = function () {
                    this.languageSelectionPageView.setInsideView(this._getPageInnerView());
                    this.languageSelectionPageView.closeLoader();
                };

                var error = function () {
                    LEManager.notifier.showError(LE.translator.translate("LEManager.manager.languageSettings.fetch.failed"));
                    LEManager.logger.error("Failed loading language settings", "LanguageSelectionController:showLanguagesPage");
                    this.languageSelectionPageView.closeLoader();
                    this._onClosePage();
                };

                this.settingsCollection.fetch({
                    groups: SettingsCollection.SETTINGS_ENUM.SETTING_GROUP.visitorLanguageSettings,
                    success: _.bind(success, this),
                    error: _.bind(error, this)
                });
            },

            getMainView:function () {
                return this.languageSelectionPageView;
            },

            _navigateOut: function() {
                LEManager.router.navigateBack();
            },

            _onClosePage: function() {
                this.stopListening(this.languageSelectionPageView);
                this._initPageComponent();
            },

            onClose: function () {
                if (!_.isUndefined(this.languageSelectionPageView) && !_.isNull(this.languageSelectionPageView)) {
                    this.languageSelectionPageView.close();
                }
                this.vent.stopListening();
            }
        });
    });
    return  LanguageSelectionController;
});

